module.exports = __webpack_public_path__ + "img/map-marker.436ae43b.svg";